import React, { useEffect, useRef } from "react";
import "./Banner.css";
import Banner_heading from "../../common/banner_heading/Banner_heading";
import Gpay_lottie from "../../Animation/gpay_lottie/Gpay_lottie";
import Banner_Badge_holder from "../../common/banner_badge_holder/Banner_Badge_holder";

function Banner() {


  return (
    <section className="Banner bg_img_holder">
      <div className="container h-100">
        <div className="row h-100">
          <div className="col-md-6">
            <div className="banner_heading_contant " data-aos="zoom-out-right">
              <div>
                <Banner_heading heading_text_1="Pay Rent & Bills " span_tag="The Smarter Way" heading_text_2="On Time, Every Time" />
                <div className="text_holder">
                  <p>Stay ahead of due dates with smart reminders, upload your electricity bill with ease, and make secure, instant payments all from one simple, powerful app.</p>
                </div>

                <div className="lottie_holder">
                  <Gpay_lottie />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6" >
            <div className="main_banner_img_mokup_holder">
              <div className="banner_img_mokup_holder">
                <div className="mockup_img_holder">
                  <img src="/assets/images/home/home-banner/mobile.png" alt="mobile" className="mobile_mock_up" />
                </div>

                <div className="cicle_img_holder">
                  <img src="/assets/images/home/home-banner/circle.png" alt="mobile" className="circle_up" />
                </div>

                <div className="bubble_img_holder bubble_up_1">
                  <img src="/assets/images/home/home-banner/home.png" alt="mobile" className="bubble_up" data-aos="tilt" />
                </div>

                <div className="bubble_img_holder bubble_up_2">
                  <img src="/assets/images/home/home-banner/cable.png" alt="mobile" className="bubble_up" data-aos="tilt" />
                </div>


                <div className="Badge_holder Badge_holder_1">
                  <Banner_Badge_holder text={"Rent"} />
                </div>

                <div className="Badge_holder Badge_holder_2">
                  <Banner_Badge_holder text={"Bill"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
